import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/Authenticaton/auth.service';
import { GlobalserviceService } from 'src/app/providers/globalservice.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ViewLocationComponent } from 'src/app/view-location/view-location.component';

@Component({
  selector: 'app-manage-geofence',
  templateUrl: './manage-geofence.component.html',
  styleUrls: ['./manage-geofence.component.scss']
})
export class ManageGeofenceComponent implements OnInit {
  displayedColumns: string[] = ['sno', 'geofencename', 'clientName', 'clientLocation', 'status', 'action'];
  dataSource = new MatTableDataSource;
  userlist: any = [];
  isLoading: boolean = false;
  @ViewChild(MatPaginator) paginator: any;
  dataList: any;
  nodata = false;
  currentPageOffset: number = 0;
  userId: number;
  orgId: number;
  constructor(private Gs: GlobalserviceService,
    private auth: AuthService,
    private router: Router,
    public dialog: MatDialog,) { }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  viewclientaddress(element: any) {
    console.log('element', element);
    const dialogRef = this.dialog.open(ViewLocationComponent, {
      disableClose: false,
      width: '700px',
      data: element
    });
  }

  ngOnInit(): void {
    let userdata = this.auth.getLocalStorageData();
    console.log(userdata);
    console.log("userId", userdata.userId);
    this.userId = userdata.userId;
    this.orgId = userdata.organization.organizationId;
    console.log("orgId", this.orgId);
    console.log(this.userId);
    this.geofenceList(this.orgId)
  }

  onPageChange(event: any) {
    this.currentPageOffset = event.pageIndex * event.pageSize;
  }

  openCreateGeofenceDialog() {
    console.log("Create");
  }

  validateSpaces(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;

    // Allow backspace without altering the input
    const inputEvent = event as InputEvent;
    if (inputEvent.inputType === 'deleteContentBackward') {
      return;
    }


    if (value.startsWith(' ')) {
      value = value.trimStart();
    }


    value = value.replace(/\s{3,}/g, '   ');

    inputElement.value = value;
  }
  applyFilter(event: any) {
    console.log("search");
    const filterValue = (event.target as HTMLInputElement).value;
    console.log(filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
    console.log(this.dataSource.filter);
    console.log(this.dataSource.filter.length);
  }
  editLocation(geofenaceId: any) {
    this.router.navigate(['geofence', geofenaceId])
  }
  geofenceList(orgId: any) {
    this.isLoading = true;
    this.Gs.get_Geofencelist(orgId).subscribe((data: any) => {
      console.log(data);
      this.dataList = data.length;
      console.log(this.dataList);
      this.dataSource = new MatTableDataSource(data);
      console.log(this.dataSource);
      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
      }, 20);
      if (data.length == 0) {
        console.log("No Data");
        this.dataList.length = 0;
        console.log(this.dataList);
        this.nodata = true;
        this.dataSource = new MatTableDataSource(this.dataList);
        console.log(this.dataSource);
        this.dataSource.paginator = this.paginator;
        console.log(this.dataSource);
      }
      this.isLoading = false;
    },
      (error) => {
        console.log("No data");
        if (error.error.errorCode == 204) {
          console.log("204 No Data", this.dataList);
          this.dataList.length = 0;
          console.log(this.dataList);
          this.nodata = true;
          this.dataSource = new MatTableDataSource(this.dataList);
          console.log(this.dataSource);
          this.dataSource.paginator = this.paginator;
          console.log(this.dataSource);
          this.isLoading = false;
        }
      }
    )
  }

  updateStatus(id: any, status: any) {
    console.log("Status", id, status);
    this.Gs.updateGeofenceStatus(id, status).subscribe((result: any) => {
      if (result.statusCode == 200) {
        // this.submitted=false;
        Swal.fire({
          text: result.description,
          icon: 'success',
          timer: 2000,
        })
        setTimeout(() => {
          this.router.navigateByUrl('/manage-geofence');
        }, 2000)
        this.geofenceList(this.orgId)
      }
      if (result.statusCode == 409) {
        Swal.fire({
          text: result.description,
          icon: 'error',
          timer: 2000
        })
        setTimeout(() => {
        }, 2000)
      }
    },
      err => {
        console.log("Error");
        Swal.fire({
          text: err.error.description,
          icon: 'error',
          timer: 2000
        })
        setTimeout(() => {
        }, 2000)
      }
    )
  }
}

